var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC1Do1LogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.194,
    height: 19.812,
    viewBox: "0 0 86.194 19.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "40q9zmemia",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.308
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#232525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#7a8182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0dcdd"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1521"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1474"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3005",
    d: "m45.329 5.338-.912.7a5.136 5.136 0 0 0-4.184-2.019 4.969 4.969 0 0 0-3.59 1.465 4.815 4.815 0 0 0-1.506 3.59 4.734 4.734 0 0 0 1.473 3.549 5.093 5.093 0 0 0 3.688 1.425 5.2 5.2 0 0 0 4.119-1.921l.912.7a5.554 5.554 0 0 1-2.182 1.734 7.011 7.011 0 0 1-2.914.594 6.2 6.2 0 0 1-4.559-1.758 6.327 6.327 0 0 1-.953-7.514A5.825 5.825 0 0 1 37 3.677a6.425 6.425 0 0 1 3.134-.8 6.927 6.927 0 0 1 3.012.635 5.573 5.573 0 0 1 2.183 1.826z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3006",
    d: "M49.106 3.173h2.3v11.69H50.25V4.311h-1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3007",
    d: "M56.367 14.863V3.173h2.426a13.231 13.231 0 0 1 3.655.366 5.191 5.191 0 0 1 2.011 1.156 5.283 5.283 0 0 1 1.3 1.929 7.143 7.143 0 0 1 .456 2.662 6.052 6.052 0 0 1-.708 2.865 4.857 4.857 0 0 1-1.921 2.027 7.222 7.222 0 0 1-3.492.684zm1.123-1.107h1.351a15.713 15.713 0 0 0 3.073-.212 3.715 3.715 0 0 0 1.669-.838 4.092 4.092 0 0 0 1.091-1.522 5.279 5.279 0 0 0 .375-2.052 5.223 5.223 0 0 0-.432-2.133 4.184 4.184 0 0 0-1.229-1.612 4.363 4.363 0 0 0-1.88-.855 17.184 17.184 0 0 0-3.183-.22h-.83z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3008",
    d: "M67.813 9.067a6.218 6.218 0 0 1 .814-3.126 5.914 5.914 0 0 1 2.23-2.247 6.085 6.085 0 0 1 3.085-.814 6.267 6.267 0 0 1 3.11.806 5.88 5.88 0 0 1 2.263 2.231 6.257 6.257 0 0 1 .008 6.187 5.912 5.912 0 0 1-2.239 2.239 6.127 6.127 0 0 1-3.093.814 6.222 6.222 0 0 1-3.1-.806 5.912 5.912 0 0 1-2.255-2.222 5.991 5.991 0 0 1-.823-3.062zm11.1-.049a4.961 4.961 0 0 0-4.966-5 4.681 4.681 0 0 0-3.509 1.457 4.917 4.917 0 0 0-1.408 3.549 4.942 4.942 0 1 0 9.883-.008z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3009",
    d: "M83.898 3.173h2.3v11.69h-1.156V4.311h-1.84z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1475"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3010",
    d: "m28.065 9.88-.137-.136-.415-.412-6.487-6.436a9.83 9.83 0 0 0-7-2.9 9.867 9.867 0 0 0-7.085 2.988L.548 9.377l-.55.55.136.135.416.413 6.487 6.434a9.83 9.83 0 0 0 7 2.9 9.867 9.867 0 0 0 7.085-2.988l6.394-6.393.55-.55zm-20.27 6.275L1.518 9.929l6.186-6.186a8.824 8.824 0 0 1 12.569-.086l6.277 6.226-6.186 6.186a8.824 8.824 0 0 1-12.562.081z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3011",
    d: "M15.644 15.49a5.875 5.875 0 0 0-1.078-11.5v12.77h-.045a5.37 5.37 0 0 1-.4.011c-.28 0-.556-.011-.574-.011a6.959 6.959 0 0 1-6.453-6.923 6.879 6.879 0 0 1 1.4-4.186 6.951 6.951 0 0 1 1.871-1.705l.014-.009a6.161 6.161 0 0 1 2.038-.855v1.111a4.8 4.8 0 0 0-.724.255 5.92 5.92 0 0 0-2.349 1.847 5.877 5.877 0 0 0 4.152 9.391V2.902h.537a6.941 6.941 0 0 1 1.611 13.69z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3012",
    d: "M114.8 149.284a5.836 5.836 0 0 1-1.989-.546l-.754.811a6.872 6.872 0 0 0 2.743.8z",
    transform: "translate(-101.304 -133.594)",
    style: {
      fill: "url(#40q9zmemia)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1Do1LogoNew);
export default __webpack_public_path__ + "static/media/c1do1-logo-new.40c71becace8939371c361c7099b8134.svg";
export { ForwardRef as ReactComponent };